import { IApplicationState } from '../../types/redux';

export const selectIsOpenAuthorizationModal = (state: IApplicationState): boolean =>
  state.calculator.authorizationModal.isOpen;
